interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ index, eyebrow, title, desc }: SectionHeadingProps) {
  return (
    <div className="mb-10 border-t border-background-300 pt-6 md:mb-14">
      <div className="mb-4 flex items-center gap-3">
        <span className="font-heading text-2xl leading-none text-accent-600">{index}</span>
        <span className="font-label text-[11px] uppercase tracking-[0.28em] text-foreground-500">
          {eyebrow}
        </span>
      </div>
      <h2 className="max-w-2xl font-heading text-2xl leading-snug text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
      ) : null}
    </div>
  );
}